import { render, staticRenderFns } from "./AddRequisitesModal.vue?vue&type=template&id=9620228e&"
import script from "./AddRequisitesModal.vue?vue&type=script&lang=js&"
export * from "./AddRequisitesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports